<template>
  <div class="postavitev-info-top">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Poleg določil sklenjenih pogodb in aneksov k pogodbam veljajo tudi določila splošnih in posebnih pogojev,
          ki so izrecno navedeni v pogodbah in aneksih. Objavljeni so
          <a :href="povezava" class="modra-barva-info" target="_blank">
            <b>tukaj</b>
          </a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {povezave} from '../../../../assets/js/Povezave/povezave'
export default {
  name: 'InfoKomponentaDokumenti',
  data () {
    return {
      povezava: povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
    }
  }
}
</script>

<style scoped>
.postavitev-info-top {
  height: 100%;
  padding-top: 50px;
}

.modra-barva-info a.krepko {
  color: unset;
}

.info-okvir {
  width: 570px;
  height: 100px;
  display: flex;
}

@media only screen and (max-width: 1100px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }

  .postavitev-info-top {
    height: unset;
    top: unset;
    left: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/InfoKomponentaDokumenti.vue